"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAddToCartLocationEvent = exports.getDefaultAddToCartLocationEvent = void 0;

var _constants = _interopRequireDefault(require("../constants"));

var _Utils = _interopRequireDefault(require("../Utils"));

var getDefaultAddToCartLocationEvent = function getDefaultAddToCartLocationEvent() {
  var addToCartLocationEvent = {
    category: {
      primaryCategory: _constants["default"].PrimaryCategories.Stash
    },
    eventInfo: {
      eventName: _constants["default"].EventNames.CartAddLocation
    },
    eventMode: _constants["default"].EventModes.Stash,
    stash: {
      pageType: '',
      sharedSection: '',
      section: '',
      component: '',
      target: _constants["default"].Targets.AddToCart,
      item: [{
        index: '',
        productID: ''
      }]
    }
  };
  return addToCartLocationEvent;
};

exports.getDefaultAddToCartLocationEvent = getDefaultAddToCartLocationEvent;

var createAddToCartLocationEvent = function createAddToCartLocationEvent(stash) {
  var addToCartLocationEvent = {};

  _Utils["default"].setEventCategory(addToCartLocationEvent, _constants["default"].PrimaryCategories.Stash);

  _Utils["default"].setEventEventInfo(addToCartLocationEvent, _constants["default"].EventNames.CartAddLocation);

  _Utils["default"].setEventProperty(addToCartLocationEvent, _constants["default"].PropertyPaths.EventMode, _constants["default"].EventModes.Stash);

  _Utils["default"].setEventProperty(addToCartLocationEvent, _constants["default"].PropertyPaths.Stash, stash);

  return addToCartLocationEvent;
}; // example of add to cart location event for THD chuck norris:
// {
//   category: {
//     primaryCategory: 'stash',
//   },
//   eventInfo: {
//     eventName: 'cart add location',
//   },
//   eventMode: 'stash',
//   stash: {
//     pageType: 'tool:diy estimates:estimates',
//     sharedSection: '',
//     section: '',
//     component: '',
//     target: 'atc',
//     item: [
//      {
//        index: '',
//        productID: ''
//      }
//     ]
//   }
// }


exports.createAddToCartLocationEvent = createAddToCartLocationEvent;
//# sourceMappingURL=addToCartLocation.js.map